<script setup lang="ts">
import {onMounted, PropType, ref} from "vue";
import {DashUser, isYapiError, YapiError} from "@YenzaCT/sdk";
import DetailRow from "@/components/DetailRow.vue";
import VAccountTypeChip from "@/components/VAccountTypeChip.vue";
import yapi from "@/lib/yapi";
import {useGlobalStore} from "@/store";

const store = useGlobalStore();

const props = defineProps({
  userId: {
    type: String as PropType<string>,
    required: false,
  }
});

const user = ref<DashUser | undefined>(undefined);
const loading = ref(true);

async function fetchUser() {
  loading.value = true;
  try {
    if (props?.userId)
      user.value = (await yapi.admin.user.get(props.userId)).data;
  } catch (e) {
    if (isYapiError(e)) {
      const yError = e as YapiError;
      await store.handleYapiError(yError);
    } else {
      throw e;
    }
  } finally {
    store.networkBusy = false;
    loading.value = false;
  }
}

onMounted(async () => {
  await fetchUser();
});

</script>

<template>
  <v-card variant="outlined" class="bg-white pa-3">
    <v-card-title>User Details</v-card-title>
    <v-card-text v-if="!user && !loading">
      <v-row>
        <v-col cols="12">
          <span class="text-grey font-weight-bold">No user details available.</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-if="user">
      <v-row>
        <v-col cols="6">
          <detail-row
            label="Name"
            data-pw="voucherDetailCode"
          >
            <template #value>
              {{ user.profile.firstName }} {{ user.profile.lastName }}
            </template>
          </detail-row>
          <detail-row
            label="Account Type"
            data-pw="voucherDetailCode"
          >
            <template #value>
              <v-account-type-chip :account-type="user.app.accountType" />
            </template>
          </detail-row>
        </v-col>
        <v-col cols="6">
          <detail-row
            label="Email"
            data-pw="voucherDetailCode"
          >
            <template v-if="user.email" #value>
              {{ user.email }}
            </template>
          </detail-row>
          <detail-row
            label="Phone"
            data-pw="voucherDetailCode"
          >
            <template v-if="user.phone" #value>
              {{ user.phone }}
            </template>
          </detail-row>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>
